import React, { useEffect, useState } from "react";
import { BiHide, BiShowAlt } from "react-icons/bi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { successNotify } from "../../Services/Notification";
import MirageLoader from "../../components/ui/pageLoader/MirageLoader";

const loginApi = `${process.env.REACT_APP_API_URL}api/user/login`;
const changePassApi = `${process.env.REACT_APP_API_URL}api/user/changepassword`;

const ChangePassword = () => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.customReducer);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [handleButton, setHandleButton] = useState({});
  const [errorsData, setErrorsData] = useState({
    currentPassword: [],
    password: [],
    password2: [],
  });
  const [userRegistration, SetUserRegistration] = useState({
    currentPassword: "",
    password: "",
    password2: "",
  });
  const [isCorrectPassword, setIsCorrectPassword] = useState();

  const user = sessionStorage.getItem("user");
  const userData = user ? JSON.parse(user) : {};
  const email = userData.email;

  const validateForm = () => {
    let passwordErrors = [];

    let formErrors = {
      currentPassword: [],
      password: [],
      password2: [],
    };
    let isValid = true;

    // Password validation
    if (!userRegistration.password) {
      passwordErrors.push("");
      formErrors.password = passwordErrors;
      isValid = false;
    } else if (userRegistration.password === userRegistration.currentPassword) {
      passwordErrors.push("You cannot repeat the existing password");
      formErrors.password = passwordErrors;
      isValid = false;
    }

    if (userRegistration.password && userRegistration.password.length < 8) {
      // formErrors.password.push('Password should be at least 8 characters long');
      passwordErrors.push("Must be atleast 8 characters long");
      formErrors.password = passwordErrors;
      isValid = false;
    }
    if (
      userRegistration.password &&
      !validatePassword(userRegistration.password)
    ) {
      // formErrors.password.push('Password should be at least 8 characters long');
      passwordErrors.push("Atleast one digit (0-9) & special character (#&@%)");
      formErrors.password = passwordErrors;
      isValid = false;
    }
    if (
      userRegistration.password &&
      !isValidPassword(userRegistration.password)
    ) {
      passwordErrors.push("Use atleast one Upper Case letter");
      formErrors.password = passwordErrors;
      isValid = false;
    }

    // Confirm password validation
    if (!userRegistration.password2) {
      formErrors.password2 = "";
      isValid = false;
    } else if (userRegistration.password2 !== userRegistration.password) {
      formErrors.password2 = "Confirm password do not match";
      isValid = false;
    }

    setErrorsData(formErrors);
    return isValid;
  };

  useEffect(() => {
    const handleValidation = async () => {
      const isFormValid = validateForm();
      if (isFormValid && isCorrectPassword) {
        setHandleButton((prev) => ({ ...prev, enable: true }));
      } else {
        setHandleButton((prev) => ({ ...prev, enable: false }));
      }
    };

    handleValidation();
  }, [userRegistration, isCorrectPassword]);

  const validateCurrentPassword = async () => {
    if (userRegistration.currentPassword) {
      try {
        const response = await axios.post(loginApi, {
          email: email,
          password: userRegistration.currentPassword,
        });
        if (response.data.message === "Invalid username or password") {
          setCurrentPasswordError("Current password mismatch");
          setIsCorrectPassword(true);
        } else if (response.data.message === "Login Success") {
          setCurrentPasswordError("");
          setIsCorrectPassword(true);
        }
      } catch (err) {
        console.log(err);
        return false;
      }
    }
    return false;
  };

  const isValidPassword = (password) => {
    const passCase = /^(?=.*[A-Z])(?=.*\d)/;
    return passCase.test(password);
  };

  const validatePassword = (password) => {
    const specialChars = /[@#$%]/;
    const numbers = /[0-9]/;
    return specialChars.test(password) && numbers.test(password);
  };

  const handleSubmit = async () => {
    setHandleButton((prev) => ({ ...prev, enable: false, loader: true }));
    changePass(changePassApi);
  };

  const changePass = async (url) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + token,
        },
        url: url,
        data: {
          password: userRegistration.password,
          password2: userRegistration.password2,
        },
      });

      if (response.status === 200) {
        successNotify(response.data.message);
        setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));

        navigate("/UzAJ/y4fN/kdSuVuxGEcEw==");
      } else {
        setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
        console.error("Password change failed:", response.data.message);
      }
    } catch (error) {
      setHandleButton((prev) => ({ ...prev, enable: true, loader: false }));
      console.error("An error occurred while changing password:", error);
    }
  };

  const togglePasswordVisibility = (passwordType) => {
    switch (passwordType) {
      case "current":
        setShowCurrentPassword(!showCurrentPassword);
        break;
      case "new":
        setShowNewPassword(!showNewPassword);
        break;
      case "confirm":
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  const registerInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    SetUserRegistration({ ...userRegistration, [name]: value });
  };

  return (
    <div className="w-full bg-[#ffffff] px-4 pb-[80px] pt-[130px]">
      <div className="mx-auto max-w-[1235px] px-[16px] md:px-0">
        <div className="flex flex-wrap items-start justify-between md:flex-nowrap">
          <div className="w-full md:w-[322px]">
            <h2 className="pb-[30px] font-open text-[24px] font-[700] leading-[36px] text-[#1E1E1E]">
              Change Password
            </h2>
            {/* <form onSubmit={handleSubmit}> */}
            <div className="mb-[12px]">
              <div className="visible-icons">
                <p className="font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]">
                  Enter Current Password*
                </p>
                <input
                  required
                  name="currentPassword"
                  onChange={(e) => registerInput(e)}
                  className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                  type={showCurrentPassword ? "text" : "password"}
                  placeholder="Current Password"
                  onBlur={validateCurrentPassword}
                />
                <button
                  className="visib-icns"
                  type="button"
                  onClick={() => togglePasswordVisibility("current")}
                >
                  {showCurrentPassword ? <BiShowAlt /> : <BiHide />}
                </button>
                {currentPasswordError && (
                  <span className="error">{currentPasswordError}</span>
                )}
              </div>
            </div>

            <div className="mb-[12px]">
              <div className="visible-icons">
                <div className="password-hover">
                  <label
                    className="mb-[5px] font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]"
                    htmlFor="password"
                  >
                    Create New Password
                  </label>
                  <div className="password-aline">
                    <div className="hover-imgs">
                      <img src="images/info-img.png" alt="" />
                    </div>
                    <div className="password-hover-show">
                      <img src="images/hovers-img.png" alt="" />
                    </div>
                  </div>
                </div>
                <input
                  required
                  onChange={(e) => registerInput(e)}
                  className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                  type={showNewPassword ? "text" : "password"}
                  placeholder="New Password"
                  name="password"
                  onBlur={validateForm}
                />
                <button
                  className="visib-icns"
                  type="button"
                  onClick={() => togglePasswordVisibility("new")}
                >
                  {showNewPassword ? <BiShowAlt /> : <BiHide />}
                </button>
              </div>
              <div className="error-btn">
                {errorsData.password.length === 1 ? (
                  <span className="error">{errorsData.password}</span>
                ) : (
                  <ul>
                    {errorsData.password.map((error, index) => {
                      return (
                        <li key={index}>
                          <span className="error">{error}</span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>
            <div className="mb-[12px]">
              <div className="visible-icons">
                <p className="font-open text-[16px] font-[600] leading-[24px] text-[#1E1E1E]">
                  Confirm Password*
                </p>
                <input
                  required
                  onChange={(e) => registerInput(e)}
                  className="mb-2 mt-[12px] w-full rounded-[8px] border border-[#B6B6B6] bg-[#F7F7F7] px-[16px] py-[12px] font-open text-[16px] font-[400] leading-[24px] text-[#999696] outline-0"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  name="password2"
                  onBlur={validateForm}
                />
                <button
                  className="visib-icns"
                  type="button"
                  onClick={() => togglePasswordVisibility("confirm")}
                >
                  {showConfirmPassword ? <BiShowAlt /> : <BiHide />}
                </button>
                {errorsData.password2 && (
                  <span className="error">{errorsData.password2}</span>
                )}
              </div>
            </div>
            <button
              className={`mt-[50px] w-full rounded-[6px] bg-pri-clr-orange px-[24px] py-[10px] font-open text-[16px] font-[600] tracking-[0.003px] text-[#ffffff] hover:bg-[#A94829] md:px-[32px] md:py-[13px] ${
                !handleButton?.enable ? "opacity-[70%]" : ""
              }`}
              type="submit"
              disabled={!handleButton?.enable}
              onClick={handleSubmit}
            >
              {handleButton?.loader ? <MirageLoader /> : "Change Password"}
            </button>
          </div>

          <div className="pt-[40px] md:pt-0">
            <h2 className="text-center font-open text-[30px] font-[700] uppercase leading-[40px] text-[#231C42] md:text-[40px] md:leading-[60px]">
              Invest{" "}
              <span className="inline-block md:block">With Confidence</span>
            </h2>
            <p className="mx-auto w-full pt-[10px] text-center font-open text-[14px] font-[600] leading-[24px] text-[#B6B6B6] md:w-[347px]">
              Unlock Your Investment Potential with Precision Portfolio
              Management
            </p>
            <div>
              <img
                className="w-full"
                src="images/Financial-growth.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
